
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"118","height":"153","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M111.907.212a.525.525 0 00-.47-.21l-.491.042c-.222-.07-12.368 1.706-12.368 1.706a.502.502 0 00-.471.518c.013.266.263.475.522.471l8.588-.742c-6.873 4.43-24.617 16.601-43.83 35.65C40.767 60.076 11.41 96.904.022 144.993c-.106.444.185.886.65.988.064.013.129.02.191.02.394 0 .75-.26.84-.643C13 97.659 42.139 61.1 64.592 38.83 84.044 19.537 101.96 7.354 108.5 3.16l-3.608 8.17a.49.49 0 00.295.62c.064.025.13.037.195.037.194 0 .38-.106.467-.284L111.95.707a.477.477 0 00-.043-.495","stroke":"#FFF","stroke-width":".7","stroke-linecap":"square","fill":"#FFF"}})])
          )
        }
      }
    